import barba from '@barba/core';

export const Barba = {
  setup: () => {
    // DESHABILITADO: Proporcionar un objeto inertia falso para evitar errores
    console.log('Barba.js está deshabilitado para prevenir problemas de navegación');
    
    // Crear un objeto falso que implemente la API completa para evitar errores
    window.inertia = {
      hooks: {
        before: (cb) => typeof cb === 'function' ? cb() : null,
        beforeEnter: (cb) => typeof cb === 'function' ? cb() : null,
        enter: (cb) => typeof cb === 'function' ? cb() : null,
        afterEnter: (cb) => typeof cb === 'function' ? cb() : null,
        beforeLeave: (cb) => typeof cb === 'function' ? cb() : null,
        leave: (cb) => typeof cb === 'function' ? cb() : null,
        afterLeave: (cb) => typeof cb === 'function' ? cb() : null,
        after: (cb) => typeof cb === 'function' ? cb() : null
      },
      // Propiedades adicionales para simular barba
      go: (url) => { window.location.href = url; return false; },
      prefetch: () => {},
      init: (config) => {
        console.log('Barba.js init llamado con configuración simulada', config);
        return window.inertia; // Retornar el objeto para encadenamiento
      },
      // Añadir objeto setup para evitar errores en common.js
      setup: {
        debug: false,
        timeout: 15000,
        transitions: {},
        views: ['home'],
        prefetchIgnore: true,
        schema: {
          prefix: 'data-solar',
        }
      }
    };
    window.useInertia = window.inertia.hooks;
  },
};
